import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';

class SettingOverdue extends Component {
  static propTypes = {
    projectOperation: PropTypes.object,
    onSaveProjectOperation: PropTypes.func,
    onChangeCountAge: PropTypes.func,
    isProjectLevel: PropTypes.bool,
    isNotAllowedEdit: PropTypes.bool,
    isHiddenCountDay: PropTypes.bool
  }

  static defaultProps = {
    projectOperation: {}
  }

  constructor(props) {
    super(props);
    this.state = {
      overdue: null,
      count: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.projectOperation) {
      this.setState({
        overdue: nextProps.projectOperation.workOrderDueIn,
        count: nextProps.projectOperation.includeWeekends
      });
    }
  }

  toolTip() {
    return (
      <Tooltip id='setting_overdue_tooltip' className='in tooltip-siteone'>
        <span>This value can be customized at project level.</span>
      </Tooltip>
    );
  }

  onSaveProjectOperationWhenChangeOverdue = (originalOverdue, newOverdue) => {
    this.setState({
      isEditOverdue: false
    });
    if (originalOverdue !== newOverdue) {
      this.props.onSaveProjectOperation(this.state.overdue);
    }
  }

  handleChangeOverdue = (e) => {
    const overdue = e.target.value;
    if (overdue <= 100) {
      if (overdue >= 1) {this.setState({overdue: e.target.value});}
      else {this.setState({overdue: 1});}
    }
  }

  onChange = () => {
    this.setState({
      count: !this.state.count
    }, () => {
      this.props.onChangeCountAge(this.state.count);
    });
  }

  render() {
    return (
      <div>
        <p style={{fontSize: 14, margin: 0}}>Overdue value is
          <span className='overdue-block'>
            <input
              type='number'
              name='overdue'
              style={this.props.isNotAllowedEdit ? {background: '#f5f5f5'} : {}}
              disabled={this.props.isNotAllowedEdit}
              className='overdue-input'
              value={this.state.overdue || ''}
              onChange={this.handleChangeOverdue}
              onFocus={() => this.setState({isEditOverdue: true})}
              onBlur={() => this.onSaveProjectOperationWhenChangeOverdue(this.props.projectOperation.workOrderDueIn, this.state.overdue)} />
            {this.state.isEditOverdue &&
              [
                <button
                  className='overdue-btn overdue-btn--save input-over-btn'
                  onClick={() => this.onSaveProjectOperationWhenChangeOverdue(this.props.projectOperation.workOrderDueIn, this.state.overdue)}>
                  <i className='fa fa-check' />
                </button>,
                <button
                  className='overdue-btn overdue-btn--cancel input-over-btn'
                  onMouseDown={() => this.setState({overdue: this.props.projectOperation.workOrderDueIn, isEditOverdue: false})}>
                  <i className='fa fa-close' />
                </button>
              ]}
          </span>
          days
          {!this.props.isProjectLevel &&
          <OverlayTrigger placement='top' overlay={this.toolTip()}>
            <i className='overdue-tooltip-ic fa fa-question-circle'/>
          </OverlayTrigger>
          }
        </p>
        {
          !this.props.isHiddenCountDay &&
          <div style={{fontSize: 14, marginTop: 10}}>
            <CheckBoxSingle
              checked={this.state.count}
              isRebind='true'
              ref={c => { this.count = c; }}
              name='count'
              label='Include weekends'
              className='checkbox-default noteTitle'
              onChecked={() => this.onChange()} />
          </div>
        }

      </div>
    );
  }
}

export default SettingOverdue;




// WEBPACK FOOTER //
// ./src/Setting/Components/setting-overdue.js